import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

export default class extends Controller {
  static targets = ["popover", "form", "input", "results", "resetButton"]
  static values = { minLength: Number }

  open() {
    this.popoverTarget.showPopover()
    this.inputTarget.focus()
  }

  close() {
    this.popoverTarget.hidePopover()
    this.inputTarget.blur()
  }

  reset() {
    this.inputTarget.value = ""
    this.inputTarget.focus()
    this.#hideResults()
    this.#hideResetButton()
  }

  input({ target: { value } }) {
    if (value.trim().length !== 0) {
      this.#showResetButton()
      this.#submit()
    } else {
      this.#hideResetButton()
      this.#hideResults()
    }
  }

  #submit = debounce(() => {
    if (this.inputTarget.value.trim().length >= this.minLengthValue) {
      this.formTarget.requestSubmit()
    }
  }, 1000)

  #hideResults() {
    this.resultsTarget.innerHTML = ""
  }

  #hideResetButton() {
    this.resetButtonTarget.classList.add("hidden")
  }

  #showResetButton() {
    this.resetButtonTarget.classList.remove("hidden")
  }
}
